import './Loader.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement, useEffect, useRef, useState } from 'react';
import { S_ClipLoader } from '../../design/loaders/clipLoader/S_ClipLoader';

interface ILoaderProps {
  isLoading: boolean;
  solid?: boolean;
  hideSpinner?: boolean;
  message?: string | string[];
}

export const Loader = observer((props: PropsWithChildren<ILoaderProps>): ReactElement => {
  const [showMessage, setShowMessage] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    handleMessage();

    return (): void => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    };
  }, [props.message, props.isLoading]);

  const handleMessage = (): void => {
    if (!props.isLoading) {
      setShowMessage(false);
    }

    if (showMessage || !props.message || timeoutRef.current !== undefined) {
      return;
    }

    timeoutRef.current = setTimeout((): void => {
      setShowMessage(true);
    }, 2000);
  };

  return (
    <>
      <div className={classNames('app-loader', { loading: props.isLoading, solid: props.solid })}>
        {!props.hideSpinner && <S_ClipLoader loading={props.isLoading} />}
        {props.isLoading && showMessage && [props.message ?? []].flat().map((message) => <h5 key={message}>{message}</h5>)}
      </div>
      {props.children}
    </>
  );
});
